<template>
  <article class="accordion">
    <div class="accordion-header">
      <h3 class="is-size-5 has-text-weight-bold">Order Type <img src="@/assets/img/yup.png"/></h3>
      <span class="action hover-opacity-7" @click="editStep()">EDIT</span>
    </div>
    <div class="accordion-body">
      <div class="accordion-content">
        <div class="checkout-accordion-content-wrap">
            <h3 class="accordion-title is-size-5 has-text-weight-bold">Order Type</h3>
            <div class="checkout-accordion-content">
              <!-- <p class="is-size-16"><strong>Dear Customer</strong></p>
              <p class="mb20">If your order subtotal is over $200.00 we have to process it in store, please select pay at store, we'll take care of it!</p> -->

              <!-- Order pickup / Delivery -->
              <p
                class="mt-5 is-size-16 has-text-weight-bold"
                v-if="enablePickup || enableDelivery"
              >How would you like to receive your order?</p>

              <p class="mt-5 bg-secondary text-white pa5 mb5" v-else>Pickup and Delivery currently unavailable.</p>

              <validation-provider
                v-show="enablePickup || enableDelivery"
                name="Receive Order Method"
                ref="order_receive_method"
                :rules="'required'"
              >
                <template #default="{ errors }">
                              
                  <div class="is-flex is-full mb10">
                    <div class="field is-half-width mt-5" v-if="enablePickup">
                      <input
                        class="is-checkradio"
                        name="ordertype"
                        v-model="order_receive_method"
                        id="order_receive_pickup"
                        type="radio"
                        value="pickup"
                      />
                      <label for="order_receive_pickup">Pickup</label>
                    </div>

                    <div class="field is-half-width mt-5" v-if="enableDelivery">
                      <input
                        class="is-checkradio"
                        name="ordertype"
                        v-model="order_receive_method"
                        id="order_receive_delivery"
                        type="radio"
                        value="delivery"
                      />
                      <label for="order_receive_delivery">Delivery</label>
                    </div>
                  </div>
                   <span class="validation-error">{{ errors[0] }}</span>
                </template>
              </validation-provider>

              <!-- pickup / delivery notices -->
              <p 
              class="pickup-notice mb20" 
              v-if="enablePickup && order_receive_method == 'pickup' 
              && vg_selectedStore.settings.pickup_orders 
              && vg_selectedStore.settings.pickup_orders.order_notice">{{vg_selectedStore.settings.pickup_orders.order_notice}}</p>

              <p
                v-if="order_receive_method == 'delivery' && vg_selectedStore.settings.delivery_orders"
                class="delivery-note"
              >We only deliver within {{parseFloat( vg_selectedStore.settings.delivery_orders.delivery_radius )}}km</p>

              <p
                class="has-text-warning"
                v-if="!vg_selectedStore.settings.delivery_orders && order_receive_method == 'delivery'"
              >
                <em>Location doesnot have delivery profile.</em>
              </p>

              <!-- Order pickup /delivery ends -->

              <!-- Shipping details -->
              <div
                class="shipping-fields mb20"
                v-show="order_receive_method == 'delivery' && vg_selectedStore.settings.delivery_orders"
              >
                <p
                  class="mb20"
                >{{ (vg_selectedStore.settings.delivery_orders && vg_selectedStore.settings.delivery_orders.delivery_notice) ? vg_selectedStore.settings.delivery_orders.delivery_notice : '' }}</p>

                <ValidationObserver
                ref="delivery_form"
                  v-show="order_receive_method == 'delivery'"
                >
                  <div class="field">
                    <div class="control">
                      <validation-provider
                        name="Address 1"
                        ref="address1"
                        rules="required"
                      >
                        <template #default="{ errors }">
                          <gmap-autocomplete
                            id="delivery_address"
                            autocomplete="nope"
                            class="input has-bg-grey google-autocomplete has-text-black"
                            style="height: 2.625rem; padding: 10px 15px 10px 20px; color: #666666; font-size: 0.9375rem; background-color: #ffff; border:1px solid #e5e5e5; box-shadow: none; border-radius: 4px; border: none; width: 100%;"
                            large
                            name="address1"
                            placeholder="Address 1"
                            @place_changed="setPlace"
                            @keyup="resetPlace"
                            :select-first-on-enter="true"
                            :componentRestrictions="{ country: vg_selectedStoreCountryShortcode }"
                          >
                          </gmap-autocomplete>
                          <p class="is-size-12 is-italic has-text-weight-light mt5">Please type in your address and select one from suggestions.</p>
                          <span
                            class="validation-error"
                            v-if="deliveryAddress1Error"
                          >{{ deliveryAddress1Error }}</span>
                        </template>
                      </validation-provider>
                    </div>
                  </div>

                  <div class="field">
                    <div class="control">
                      <validation-provider name="unit-buzz" ref="address2">
                        <template #default="{ errors }">
                          <input
                            v-model="delivery.address2"
                            class="input"
                            name="unit-buzz"
                            type="text"
                            placeholder="Unit / Buzz"
                          />
                          <span class="validation-error">{{ errors[0] }}</span>
                        </template>
                      </validation-provider>
                    </div>
                  </div>

                  <div class="field">
                    <div class="control">
                      <validation-provider
                        name="Province"
                        ref="province"
                        rules="required"
                      >
                        <template #default="{ errors }">
                          <input
                            v-model="delivery.province"
                            :class="'input' + (delivery.address1 ? '' : ' disable-field')"
                            name="province"
                            type="text"
                            placeholder="Province"
                            :disabled="delivery.address1 == ''"
                          />
                          <span class="validation-error">{{ errors[0] }}</span>
                        </template>
                      </validation-provider>
                    </div>
                  </div>

                  <div class="field">
                    <div class="control">
                      <validation-provider name="City" ref="city" rules="required">
                        <template #default="{ errors }">
                          <input
                            v-model="delivery.city"
                            :class="'input' + ( delivery.address1 ? '' : ' disable-field')"
                            name="City"
                            type="text"
                            placeholder="City"
                            :disabled="delivery.address1 == ''"
                          />
                          <span class="validation-error">{{ errors[0] }}</span>
                        </template>
                      </validation-provider>
                    </div>
                  </div>

                  <div class="field">
                    <div class="control">
                      <validation-provider
                        name="Postal Code"
                        ref="postal_code"
                        rules="required|min:6"
                      >
                        <template #default="{ errors }">
                          <input
                            v-model="delivery.postal_code"
                            name="Postal code"
                            type="text"
                            placeholder="Postal code"
                            :class="'input' + (delivery.address1 ? '' : ' disable-field')"
                            :disabled="delivery.address1 == ''"
                          />
                          <span class="validation-error">{{ errors[0] }}</span>
                        </template>
                      </validation-provider>
                    </div>
                  </div>
              

                  <div class="field">
                    <div class="control">
                      <validation-provider name="Note" ref="note">
                        <template #default="{ errors }">
                          <textarea
                            :maxlength="250"
                            v-model="delivery.note"
                            class="input text-area"
                            name="Delivery Note"
                            type="text"
                            placeholder="Delivery Note (Max length: 250)"
                          ></textarea>
                          <span class="validation-error">{{ errors[0] }}</span>
                        </template>
                      </validation-provider>
                    </div>
                  </div>

                  <div class="field">
                    <div class="control">
                      <validation-provider
                        name="Phone"
                        ref="phone"
                        :rules="delivery.phone ? 'required|phone_number' : 'required|phone_number'"
                      >
                        <template #default="{ errors }">
                          <input
                            onkeydown="javascript: return event.keyCode == 69 || event.which == 109 ? false : true"
                            v-model="delivery.phone"
                            class="input hide-arrow"
                            name="Phone"
                            type="number"
                            placeholder="Delivery Phone"
                          />
                          <span class="validation-error">{{ errors[0] }}</span>
                        </template>
                      </validation-provider>
                    </div>
                  </div>
                </ValidationObserver>
              </div>
              <!-- Shiopping details ends -->

              <!-- pickup / delivery order time select -->
          
              <div class="content-box pickup-time" v-if="vg_selectedStore && show_timeSlots">
                <div class="field">
                  <h3
                    class="title is-size-16 mb5 has-text-weight-bold"
                  >{{ order_receive_method == 'pickup' ? 'Pickup Time' : 'Preferred Delivery Time'}}</h3>
              
                  <template v-if="loadedTimeSlots">
                    
                    <div class="pickup-delivery-time-wrap"  v-if="vg_selectedStore && show_timeSlots">
                      <validation-provider
                        :name="order_receive_method == 'pickup' ? 'Pickup Time' : 'Delivery Time'"
                        ref="pickuptime"
                        :rules="'required'"
                      >
                        <template #default="{ errors }">
                          <div class="select has-background time-lost-align is-width-full">
                            <select v-model="pickupTime">
                              <option value>-- Select --</option>
                              <option
                                v-bind:key="'hours_' + index"
                                v-for="(time, index) in selectedLocationTimeSlots"
                                :value="time"
                              >{{ dropDownDateTimeReadableFormat(time) }}</option>
                            </select>
                          </div>
                          <span class="validation-error">{{ errors[0] }}</span>
                        </template>
                      </validation-provider>
                    </div>
                    
                    <p v-else>
                      <em class="text-white">{{ pickupTime }}</em>
                    </p>
                  </template>

                  <p v-else>
                    <em class="text-white">Fetching location hours...</em>
                  </p>
                </div>
              </div>
              <!-- Select time ends -->

              <location-selected :marker="true" :headingclass="'title mb0 is-size-16 has-text-weight-bold'" class="mt20"/>
       
              <!-- If user is not logged in and  reward is skipped -->
              <div class="order-customer-details mt20" v-if="!vg_userId && (vg_checkoutReward.type == 'skip')">
                <!-- <p class="mt-5 is-size-16 has-text-weight-bold mb20">Who is getting your order?</p> -->
                <p class="mt-5 is-size-16 has-text-weight-bold mb20">Order details</p>
                <div class="form-field-inline">
                  <div class="field">
                    <div class="control">
                      <validation-provider name="first name" ref="order_user_first_name" rules="required|min:2">
                        <template #default="{ errors }">
                          <input
                            v-model="user.first_name"
                            autocomplete="new-password"
                            class="input checkout-user-field"
                            name="first_name"
                            type="text"
                            placeholder="First Name *"
                          />
                          <span class="validation-error">{{ errors[0] }}</span>
                        </template>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="field">
                    <div class="control">
                      <validation-provider name="last name" ref="order_user_last_name" rules="required|min:2">
                        <template #default="{ errors }">
                          <input
                            v-model="user.last_name"
                            autocomplete="new-password"
                            class="input checkout-user-field"
                            name="last_name"
                            type="text"
                            placeholder="Last Name *"
                          />
                          <span class="validation-error">{{ errors[0] }}</span>
                        </template>
                      </validation-provider>
                    </div>
                  </div>
                </div>
                
                <div class="field">
                  <div class="control">
                    <validation-provider name="email" ref="order_user_email" rules="required|email">
                      <template #default="{ errors }">
                        <input
                          v-model="user.email"
                          autocomplete="new-password"
                          :class="'input checkout-user-field'+ ($store.getters.getLoggedInUserToken ? ' field-disabled' : '')"
                          name="email"
                          type="text"
                          placeholder="Email *"
                          rules="required|email"
                        />
                        <span class="validation-error">{{ errors[0] }}</span>
                      </template>
                    </validation-provider>
                  </div>
                </div>

                <div class="field">
                  <div class="control">
                    <validation-provider name="phone" ref="order_user_phone" rules="required|phone_number|numeric">
                      <template #default="{ errors }">
                        <input
                          v-model="user.phone"
                          :class="'input checkout-user-field hide-arrow'+ ($store.getters.getLoggedInUserToken ? ' field-disabled' : '')"
                          name="phone"
                          rules="required|phone_number|numeric"
                          type="number"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          placeholder="Phone Number *"
                        />
                        <span class="validation-error">{{ errors[0] }}</span>
                      </template>
                    </validation-provider>
                  </div>
                </div>
              </div>

              <div class="user-note">
                <textarea name="usernotes" class="usernote input text-area is-size-16px" placeholder="Special Instructions (Optional)" v-model="note"/>
              </div>

              <template v-if="vg_selectedStore.settings && vg_selectedStore.settings.delivery_orders && vg_selectedStore.settings.delivery_orders.enable_tips">
              <div class="user-tip" v-if="order_receive_method != 'pickup'">
                <p class="mt-5 is-size-16 has-text-weight-bold mb5 mt20">Tip your courier</p>
                <ul>

                  <li v-for="(tipItem,index) in tipDefinedPercents" v-bind:key="'tip'+tipItem.value">
                    <div :class="'tip-item' + (tipItem.active ? ' active' : '')" @click.prevent="selectTip(index)">
                      <strong>{{ tipItem.label }}</strong>
                      <span>${{ getTipPercentIntoAmt(tipItem.value) }}</span></div>
                  </li>

                  <li>
                    <div>

                      <div class="custom-tip-item custom-tip-title" v-if="!tip.custom" @click.prevent="selectCustomTip()">EDIT</div>
                      <div :class="'custom-tip-edit custom-tip-item' + (tip.custom ? ' active' :'')" v-else>
                        <div class="tip-custom-price">
                          <em>$</em><input id="customtip" type="number"  onkeydown="javascript: return event.keyCode == 187 || event.which == 189 ? false : true" v-model.number="tip.amount" placeholder="0.00"/>
                        </div>
                        <label for="customtip" class="edit">Edit</label>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              </template>

              <div class="pickup-delivery-timeslot-disable-note" v-if="!pickupDeliveryTimeSlotStatusWhenStoreClosed && defaultPickupTime">
                <h4 class="has-text-weight-bold is-size-16 mt15">{{ order_receive_method == 'pickup' ? 'Pickup Time' : 'Delivery Time' }}</h4>
                <p class="is-size-14px" v-if="order_receive_method == 'pickup'">This store is currently closed. If you place an order, you won’t be able to pick it up until <strong>{{ pickupTime ? pickupTime : defaultPickupTime }}</strong>. You will receive an email once your order is ready for pickup!</p>
                <p class="is-size-14px" v-if="order_receive_method == 'delivery'">This store is currently closed. If you place an order, we  won’t be able to deliver it up until <strong>{{ pickupTime ? pickupTime : defaultPickupTime }}</strong>. You will receive an email once your order is accepted.</p>
              </div>

              <div class="accordion-action mt20 has-text-right">
                <p v-if="order_receive_method == 'delivery'" class="is-size-14 mt5 mb15">Please confirm delivery address and continue.</p>
                <a
                @click.prevent="nextStep()"
                href="#"
                class="button is-fullwidth-mobile bg-secondary text-white hover-opacity-7 btn-complete"
              >
                CONTINUE
              </a>
              </div>

            </div>
        </div>
      </div>
    </div>
  </article>
</template>


<script>
import LocationApis from '@/Components/Controllers/LocationApis';
import LocationSelected from '@/Components/Pages/Inc/SelectedLocation';
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';
//import { find, indexOf } from 'lodash';
import moment from 'moment';

export default {
  components: {
    LocationSelected,
  },
  name: 'CheckoutOrderType',
  data() {
    return {
      delivery_cutoff: false,
      order_receive_method: 'pickup',
      delivery_fee: 0.00,
      deliveryAddress1Error: '',
      deliveryAddressPass: {
        status: false,
        message: '',
      },
      note: '',
      delivery: {
        address1: '',
        address2: '',
        province: '',
        city: '',
        postal_code: '',
        note: '',
        phone: '',
        latitude: '',
        longitude: '',
        country: '',
        country_code: '',
      },
      
      tipDefinedPercents: [
        {
          label: '15%',
          value: 15,
          active: false,
        },
        {
          label: '20%',
          value: 20,
          active: false,
        },
        {
          label: '25%',
          value: 25,
          active: false,
        },
        {
          label: '30%',
          value: 30,
          active: false,
        }
      ],
      tip: {
        selected: {},
        amount: '',
        custom: false,
      },

      loadedTimeSlots: false,
      selectedLocationTimeSlots: [],
      pickupTime: '',

      user: {
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        sms_notification: false,
        email_notification: false,
        marketing_notification: false
      },

    };
  },
  computed: {
    /**
     * When no time slots available for reveive Time
     */
    defaultPickupTime() {
       // If pickup is balnk but store is open 
        if(this.vg_selectedStore.currently_open) {
          // Add 30minutes on current time
          return Helpers.storeNowAddedTime(this.vg_selectedStore, 30);
        } else {
          // if store closed, // Next day opening time
          return  this.order_receive_method == 'pickup' ? Helpers.storeNextOpenDateTime(this.vg_selectedStore, 'pickup') : Helpers.storeNextOpenDateTime(this.vg_selectedStore, 'delivery');      
        }
    },
    /**
     * When timeslot for an individual method is disabled
     */
    pickupDeliveryTimeSlotStatusWhenStoreClosed() {
      // if show time slot that mes this is afalse, we do not show note while timeslot is true
      if(this.order_receive_method == 'pickup' && this.enablePickup && (this.vg_selectedStore.currently_open == false)){
        return (this.vg_selectedStore && this.vg_selectedStore.settings && this.vg_selectedStore.settings.pickup_orders ) ? this.vg_selectedStore.settings.pickup_orders.use_timeslots : false;
      } else if (this.order_receive_method == 'delivery' && this.enableDelivery && (this.vg_selectedStore.currently_open == false) ){
        return (this.vg_selectedStore && this.vg_selectedStore.settings && this.vg_selectedStore.settings.delivery_orders ) ? this.vg_selectedStore.settings.delivery_orders.use_timeslots : false;
      } else {
        return true;
      }
    },
    
    /**
     * Guest user / guest_only active
     */
    kioskMode() {
       return (this.$route.query['kiosk'] && ( (this.$route.query['kiosk'] == 1) || (this.$route.query['kiosk'] == 'true') ) ) ? true : false;
    },
    
     /**
     * Enable pickup
     */
    enablePickup() {
      // if guest only then pickup always enabled
      if (this.kioskMode == true) {
        return true;
      }
      return this.vg_selectedStore.settings.pickup_orders ? this.vg_selectedStore.settings.pickup_orders.is_enabled && this.vg_selectedStore.settings.pickup_orders.is_active : false
    },

     /**
     * Enable delivery 
     */
    enableDelivery() {
      // if guest user is true then we need to hide delivery
      // sometime we are not getting delivery_orders key so if key not present disable 
      if (
        this.delivery_cutoff == false &&
        this.vg_selectedStore.settings &&
        this.vg_selectedStore.settings.delivery_orders &&
        this.vg_selectedStore.settings.delivery_orders.is_enabled &&
        this.vg_selectedStore.settings.delivery_orders.is_active &&
        this.vg_selectedStore.delivery_currently_available &&
        (this.kioskMode == false)
      ) {
        return true;
      }
      // If guest only delivery is always false
      return false;
    },
    /**
     * Timeslots show default , if user is guest--only and user is false , hide it
     */
    show_timeSlots() {
  
      if (this.kioskMode) {
        return this.vg_selectedStore.settings.kiosk_settings ? this.vg_selectedStore.settings.kiosk_settings.use_timeslots : true
      }

      if (this.order_receive_method === 'pickup') {
        return this.vg_selectedStore.settings.pickup_orders ? this.vg_selectedStore.settings.pickup_orders.use_timeslots : true
      } else if (this.order_receive_method === 'delivery') {
        // on next tick add attribute on autocomplete, not workiong so lets settime out for 1 sec to add
        // setTimeout(function(){
        //   // once the div loaded change it 
        //   document.getElementById("delivery_address").setAttribute("autocomplete", "nope");
        // }, 1000)
        return this.vg_selectedStore.settings.delivery_orders ? this.vg_selectedStore.settings.delivery_orders.use_timeslots : true
      }
      return true;
    },

    /**
     * Calculate total with delivery fee
     */
    cartGrandTotalWithDelivery() {
      return parseFloat(this.vg_cartGrandTotal) + parseFloat(this.delivery_fee);
    },

    ...mapGetters({
      vg_cartId: "cart/id",
      vg_userId: "getLoggedInUserId",
      vg_user: "getLoggedInUser",
      vg_businessprofile: "businessprofile/detail",
      vg_cartItems: "cart/cartItems",
      vg_is_greenline_pos: "location/is_greenline_pos",
      vg_is_tendy_pos: "location/is_tendy_pos",
      vg_selectedStore: "location/selected",
      vg_selectedStoreCountryShortcode: "location/selectedLocationCountryShortcode",
      vg_cartSubTotal: "cart/cartSubTotal",
      vg_cartTax: "cart/cartTax",
      vg_cartPromoCode: "cart/promocode",
      vg_cartGrandTotal: "cart/cartGrandTotal", // with tax calculation
      vg_weightOnCart: "cart/cartWeight",
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_checkoutReward: "checkout/reward",
      vg_checkoutOrderType: "checkout/ordertype",
    }),
  },

  watch: {
    'user.email'(val) {
      this.user.email = val.replaceAll(/\s/g,'').trim();
    },
    'delivery.phone'(val, oldVal) {
      if (val && val.length > 10) {
        this.delivery.phone = oldVal;
      }
    },
    'user.phone'(val, oldVal) {
      if (val && val.length > 10) {
        this.user.phone = oldVal;
      }
      
    },

    'tip.amount'(val) {

      this.va_setOrderTypeValueByKeys({
        tip: val ? val : 0,
      });


      if(this.vg_is_greenline_pos) {
        this.fetchGreenLinePosData();
      } else if(this.vg_is_tendy_pos) {
        this.fetchTendyPosData()
      }


    },

    vg_cartItems: {
      deep: true,
      async handler(){
        // If cart item changed and is delivery 
        if(
          this.order_receive_method == 'delivery'
          && this.vg_checkoutOrderType.delivery
          && this.vg_checkoutOrderType.delivery.latitude
          && this.vg_checkoutOrderType.delivery.longitude
        ) {
          // Refetch the cart delivery fee
          let newDeliveryFee = 0;
          let deliveryFeeData =  await this.calculateDeliveryFee(this.vg_checkoutOrderType.delivery.latitude, this.vg_checkoutOrderType.delivery.longitude);
          if(deliveryFeeData.status == 200){
            // lets push delivery fee on change value
            newDeliveryFee = deliveryFeeData.data.payload.delivery_fee ? deliveryFeeData.data.payload.delivery_fee.toFixed(2) : 0;
          } else {
            let deliveryErrMsg = deliveryFeeData.response.data  ? deliveryFeeData.response.data.msg : 'Sorry unable to get delivery response.';
            // reset 
            document.getElementById('delivery_address').value = '';
            this.delivery = {
              address1: '',
              address2: '',
              province: '',
              city: '',
              postal_code: '',
              latitude: '',
              longitude: '',
              country: '',
              country_code: '',
              phone: this.vg_checkoutOrderType.delivery && this.vg_checkoutOrderType.delivery.phone ? this.vg_checkoutOrderType.delivery.phone : '' ,
              note: this.vg_checkoutOrderType.delivery && this.vg_checkoutOrderType.delivery.note ? this.vg_checkoutOrderType.delivery.note : '',
            };
            this.$refs.delivery_form.reset();

            this.va_snackbar({
              type: "warning",
              message: deliveryErrMsg,
            });
            
            bus.$emit('checkout-step', {
              step: 'ordertype',
            })
          }
          this.va_setOrderTypeValueByKeys({
            delivery_fee: newDeliveryFee,
          });

        }
      }
    },

    // watch cart item if changed from another tabs sync
    order_receive_method(val) {
      // Reset data on chnage type
      this.resetCheckoutdata(false);
      this.deliveryAddressPass = {
        status: false,
        message: '',
      };
      
      this.va_setCartLoyalityPointsObj({
        order_receive_method: val,
      });

      if(val == 'pickup' && this.vg_is_greenline_pos) {
        this.fetchGreenLinePosData();

      } else if(val == 'pickup' && this.vg_is_tendy_pos) {
        this.fetchTendyPosData()
      }

      const self = this;
      this.loadedTimeSlots = false;
      this.pickupTime = '';
      this.delivery_fee = 0.00;
      const locationTimeSlotsPromise = LocationApis.timeSlots(this.vg_selectedStore.slug, this.order_receive_method);
      Promise.all([locationTimeSlotsPromise]).then(function (res) {
        if (res[0].status && res[0].status == 200) {
          self.selectedLocationTimeSlots = res[0].data.payload
        } else {
          self.selectedLocationTimeSlots = []
        }
        // added to select a default pickup time
        self.pickupTime = self.selectedLocationTimeSlots.length > 0 ? self.selectedLocationTimeSlots[0] : '';
        self.loadedTimeSlots = true;
      });
      // if method is pickup then clear delivery fields
      if(this.order_receive_method == 'pickup') {
        this.delivery = Helpers.setObjValueEmpty(this.delivery);
        this.resetTip();
      } else {
        // If user is logged in set the value
        if(this.vg_user && this.vg_user.phone) {
          this.delivery.phone = this.vg_user.phone;
        }
       
      }
      this.va_setOrderTypeValueByKeys({
        order_receive_method: this.order_receive_method,
        delivery_fee: this.delivery_fee,
        delivery: {},
      });
    },
  },


  async mounted() {
    const self = this;
    this.resetTip();
    this.getLocationTimeZoneTime();
    setInterval(() => {
      // Run this on every 1 min, so that we get latest data if user keeps on hold 
      this.getLocationTimeZoneTime();
    }, 60000);
    let timeSlotRes = await LocationApis.timeSlots(this.vg_selectedStore.slug, this.order_receive_method);
    if(timeSlotRes.status == 200) {
      self.selectedLocationTimeSlots = timeSlotRes.data.payload;
    } else {
      self.selectedLocationTimeSlots = []
    }
    self.pickupTime = self.selectedLocationTimeSlots.length > 0 ? self.selectedLocationTimeSlots[0] : '';

    this.loadedTimeSlots = true;
    // auto selecting pickup/delivery
    if (this.enablePickup) {
      this.order_receive_method = 'pickup'
    } else if (this.enableDelivery) {
      this.order_receive_method = 'delivery'
    }
    // Flush checkout data 
    this.resetCheckoutdata(false)
  },
  
  beforeDestroy() {
    this.resetCheckoutdata(true)
  },

  methods: {
   
    /*
    * Get location timezone current time 
     */
    getLocationTimeZoneTime() {
      if (_.isEmpty(this.vg_selectedStore)) {
        // if we dont have selected location disable delivery
        this.delivery_cutoff = true;
      }
      // Get that location current date and time
      let locationCurrentMoment = moment().tz(this.vg_selectedStore.timezone ? this.vg_selectedStore.timezone : 'America/Toronto');
      let locationCurrentDay = locationCurrentMoment.format('dddd');
      let locationCurrentFullDate = locationCurrentMoment.format('YYYY-MM-DD');
      // Now get location delivery hour
      if (this.vg_selectedStore.location_delivery_hours && this.vg_selectedStore.location_delivery_hours.length > 0) {
        let todayLocationDeliveryObj = _.find(this.vg_selectedStore.location_delivery_hours, { dayName: locationCurrentDay });

        if (todayLocationDeliveryObj != undefined) {
          let todaysDeliveryCutOff = moment(locationCurrentFullDate + ' ' + todayLocationDeliveryObj.cut_off_time, 'YYYY-MM-DD HH:mm:ss');
          // if((locationCurrentMoment.diff(todaysDeliveryCutOff, 'minutes')) >= 0){ // for test
          //console.log('location cutoff  ' + locationCurrentFullDate + ' ' + todayLocationDeliveryObj.cut_off_time)
          //console.log((todaysDeliveryCutOff.diff(locationCurrentMoment, 'minutes')))

          if ((todaysDeliveryCutOff.diff(locationCurrentMoment, 'minutes')) >= 0) {
            // if location cutoff time and preset time has +ve value, open delivery
            this.delivery_cutoff = false;
          } else {
            // if -ve then we already out of time, cut off true
            this.delivery_cutoff = true;
            this.order_receive_method = 'pickup'; // force to pickup
          }
        }
      }
    },

    getTodaysOpenCloseSchedule() {
      let todaysSchedule = _.find(this.vg_selectedStore.hours_of_operation, function (o) { return o.day == new Date().getDay(); });
      if (todaysSchedule != undefined) {
        return this.getOpenCloseTime(todaysSchedule);
      }
      return '';
    },

    /**
     * autocomplete set 
     */
    setPlace: async function (addressData) {
      
      if (_.isEmpty(addressData)) {
        this.delivery.address1 = '';
        return;
      }
 
      let address = addressData.formatted_address || '';
      if (/^\d/.test(address) == false) {
          document.getElementById('delivery_address').value = '';
          return this.va_snackbar({
            type: "warning",
            message: "Cannot find your street address. Please type in with street number."
          });
      }

      if(addressData.name){
        let newAddress = addressData.formatted_address ? addressData.formatted_address.split(',') : [];
        if(newAddress.length > 1 ) {
          document.getElementById('delivery_address').value = newAddress[0] +',' +newAddress[1];
        } else {
          document.getElementById('delivery_address').value = addressData.name;
        }
      }
      this.deliveryAddress1Error = "";
      this.delivery = {
        address1: '',
        address2: '',
        province: '',
        city: '',
        postal_code: '',
        latitude: '',
        longitude: '',
        country: '',
        country_code: '',
        phone: this.delivery.phone,
        note: this.delivery.note,
      };

      // this.deliveryDistanceCheck = false;

      if (addressData) {
        let postcode = this.getDetailFromGmapAutoComplete(addressData.address_components, 'postal_code');
        if (postcode == '') {
          this.va_snackbar({
            type: "warning",
            message: "Cannot find your post code. Please type in full address."
          });
          return;
        }
        let lat;
        let lng;
        // get my location
        if (typeof addressData.geometry.location.lat === 'function') {
          lat = addressData.geometry.location.lat();
          lng = addressData.geometry.location.lng();
        } else {
          lat = addressData.geometry.location.lat;
          lng = addressData.geometry.location.lng;
        }
        // lets get the distance between the store and the delivery location
        // this.va_spinner(true);
        // let distanceRes = await this.getDistanceBetween({
        //   originLat: this.vg_selectedStore.address.latitude,
        //   originLng: this.vg_selectedStore.address.longitude,
        //   destiLat: lat,
        //   destiLng: lng,
        // });
        // this.va_spinner(false);

        if (!this.vg_selectedStore.settings.delivery_orders) {
          return this.va_snackbar({
            type: "warning",
            message: `Sorry cannot find delivery profile for the location.`,
          });
        }
          // whether is valid radious or not display details
      
        

        // if (
        //   distanceRes.distance != null &&
        //   this.vg_selectedStore.settings.delivery_orders &&
        //   parseFloat(distanceRes.distance) > parseFloat(this.vg_selectedStore.settings.delivery_orders.delivery_radius)) {
        //   // Reject is distance is greater than delivery radius
        //   this.deliveryDistanceCheck = false;
        //   return this.va_snackbar({
        //     type: "warning",
        //     message: `Sorry we only deliver within ${parseFloat(this.vg_selectedStore.settings.delivery_orders.delivery_radius)}km`,
        //   });
       
        // }

        // Delivery distance pass
       // this.deliveryDistanceCheck = true;
        //if (distanceRes.status == 200) {


          // lets calculate delivery fee here 

          // OLD METHOD USED
          // let deliveryDistance = parseFloat(distanceRes.distance).toFixed(2);
          // let baseRate = this.vg_selectedStore.settings.delivery_orders.base_fee ? this.vg_selectedStore.settings.delivery_orders.base_fee : 0;
          // let baseDistance = this.vg_selectedStore.settings.delivery_orders.base_km ? this.vg_selectedStore.settings.delivery_orders.base_km : 0;
          // let additionalFeePerKm = this.vg_selectedStore.settings.delivery_orders.additional_km_fee ? this.vg_selectedStore.settings.delivery_orders.additional_km_fee : 0;
          // let totalDeliveryCharge = baseRate;

          // if (deliveryDistance <= baseDistance) {
          //   totalDeliveryCharge = baseRate.toFixed(2);
          // } else {
          //   totalDeliveryCharge = parseFloat(baseRate) + (parseFloat(additionalFeePerKm) * (deliveryDistance - baseDistance));
          // }
          // this.delivery_fee = parseFloat(totalDeliveryCharge).toFixed(2);
          // OLD METHOD USED ENDS
          this.va_spinner(true);
          let deliveryFeeData = await this.calculateDeliveryFee(lat.toString(), lng.toString());
          this.va_spinner(false);
          if(deliveryFeeData.status == 200){
            // lets push delivery fee on change value
            this.delivery_fee = deliveryFeeData.data.payload.delivery_fee ? deliveryFeeData.data.payload.delivery_fee.toFixed(2) : 0;
            this.delivery = {
              address1: addressData.name,
              address2: this.delivery.address2,
              province: this.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_1') ? this.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_1') : this.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_2'),
              city: this.getDetailFromGmapAutoComplete(addressData.address_components, 'locality'),
              postal_code: postcode.replace(/\s/g, ""),
              latitude: lat.toString(),
              longitude: lng.toString(),
              country: this.getDetailFromGmapAutoComplete(addressData.address_components, 'country'),
              country_code: this.getDetailFromGmapAutoComplete(addressData.address_components, 'country', 'short_name'),
              phone: this.delivery.phone,
              note: this.delivery.note,
            };  
            this.deliveryAddressPass = {
              status: true,
              message: '',
            };

            
            
          } else {
            this.delivery_fee = 0;
            //reset
            document.getElementById('delivery_address').value = '';
            let deliveryErrMsg = deliveryFeeData.response.data  ? deliveryFeeData.response.data.msg : 'Sorry unable to get delivery response.';
            this.deliveryAddressPass = {
              status: false,
              message: deliveryErrMsg,
            };
            this.va_snackbar({
              type: "warning",
              message: deliveryErrMsg,
            });
          }
          await this.va_setOrderTypeValueByKeys({
            order_receive_method: this.order_receive_method,
            delivery_fee: this.delivery_fee,
            delivery: deliveryFeeData.status == 200 ? this.delivery : {},
          });


          if(this.vg_is_greenline_pos && deliveryFeeData.status == 200) {
            this.fetchGreenLinePosData();
          } else if(this.vg_is_tendy_pos && deliveryFeeData.status == 200) {
            this.fetchTendyPosData()
          }
          
    
      }
    },

    /**
     * Calculate delivery price for location
     */
    async calculateDeliveryFee(lat, lng) {
      return await LocationApis.getLocationDeliveryFee({
        location_id: this.vg_selectedStore.id,
        lat, 
        lng, 
        cart_total: this.vg_cartSubTotal,
      });
    },

    /**
     * Reset address
     */
    resetPlace: function () {

      let deliveryAddress = document.getElementById('delivery_address').value;
      if (deliveryAddress == undefined || deliveryAddress == '') {
        // now reset 
        this.delivery.address1 = '';
        // this.delivery.addreess2 = '';
        this.delivery.address2 = '';
        this.delivery.province = '';
        this.delivery.city = '';
        this.delivery.postal_code = '';
        this.delivery.latitude = '';
        this.delivery.longitude = '';
        return this.deliveryAddress1Error = "Address cannot be blank.";
      } else {
        // this.delivery.address1 = deliveryAddress; // set typed value
        this.deliveryAddress1Error = "";
      }
    },

    /**
     * Get the value from gmap auto component
     */
    getDetailFromGmapAutoComplete(address_components, key, targetValue = '') {
      let returnValue = '';
      let searchdata = address_components.find(item => {
        if (_.indexOf(item.types, key) > -1) {
          return item;
        }
      })
      if (searchdata != undefined) {
        returnValue = targetValue ? searchdata[targetValue] : searchdata.long_name;
      }
      return returnValue;
    },

    /**
     * Get distance between to points
     */
    async getDistanceBetween({ originLat, originLng, destiLat, destiLng }) {
      let shortestDiatance = await this.getDistanceFromLatLonInKm(originLat, originLng, destiLat, destiLng);
      if (shortestDiatance != null) {
        return {
          status: 200,
          distance: shortestDiatance.toFixed(2),
        }
      } else {
        this.va_snackbar({
          type: "warning",
          message: "Cannot find the driving distance."
        });
        return {
          status: 400,
          distance: null,
        }
      }
    },

    /**
     * Get sortest distance via earh radious calculation
     */
    getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
      var R = 6371; // Radius of the earth in km
      var dLat = this.deg2rad(lat2 - lat1);  // this.deg2rad below
      var dLon = this.deg2rad(lon2 - lon1);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2)
        ;
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c; // Distance in km
      return d;
    },

    /**
     * Convert deg to rand
     */
    deg2rad(deg) {
      return deg * (Math.PI / 180)
    },

     /**
     * Concert time to new readable format 
     */
    dropDownDateTimeReadableFormat(dropDownTime) {
      let a = moment(dropDownTime, "YYYY-MM-DD hh:mm a");
      return a.format('MMMM DD, YYYY @ h:mm A');
    },

    todayDayNumber() {
      return new Date().getDay();
    },
    
    // Get opening and closing time for all the days of week
    getOpenCloseTime(item) {
      return `${moment(item.open_time, "HH:mm:ss").format("hh:mm a")} - ${moment(item.close_time, "HH:mm:ss").format("hh:mm a")}`;
    },

    /**
     * Edit this step 
     * */  
    editStep() {
      bus.$emit('checkout-step', {
        step: 'ordertype',
      })
    },

    /**
     * Continue next step
     */
    async nextStep() {
      // if pickup and delivery both are disabled then return message
      if( !this.enablePickup && !this.enableDelivery){
        return this.va_snackbar({
          type: "warning",
          message: 'Pickup and Delivery currently unavailable!',
        });
      }

      this.deliveryAddress1Error = "";
      let validationKeys;

      if (this.order_receive_method == 'delivery') {
        // check the address
        let deliveryAddress = document.getElementById('delivery_address').value;
        if (deliveryAddress == undefined || deliveryAddress == '') {
          // now reset 
          this.delivery.address1 = '';
          this.delivery.address2 = '';
          this.delivery.province = '';
          this.delivery.city = '';
          this.delivery.postal_code = '';
          this.delivery.latitude = '';
          this.delivery.longitude = '';
          return this.deliveryAddress1Error = "Address cannot be blank.";
        }

       // this.delivery.address1 = document.getElementById('delivery_address').value; // set typed value
       // Add address only by selecting google dropdown
        if (this.delivery.address1 == '') {
          this.deliveryAddress1Error = "Invalid address. Please select one from suggestions.";
          return;
        }
        // User might have change the field value so lets get the latest value
        this.delivery.address1 = document.getElementById('delivery_address').value;
        // Delivery validation
        validationKeys = ['order_receive_method', 'province', 'city', 'postal_code', 'phone'];
        // Must be within delivery distance
        if(!this.deliveryAddressPass.status){
          return this.va_snackbar({
            type: "warning",
            message: this.deliveryAddressPass.message,
          });
        }
      } else {
        // Pickup validation
        validationKeys = ['order_receive_method'];
      }

      // If enabled
      if(this.show_timeSlots){
        validationKeys.push('pickuptime');
      }

      // If user is not logged in need to validate user details
      if(!this.vg_userId && (this.vg_checkoutReward.type == 'skip')){
        let userValidation =  ['order_user_first_name', 'order_user_last_name', 'order_user_email', 'order_user_phone'];
        validationKeys = [...userValidation, ...validationKeys];
      }

      let validation = await Helpers.validateRefs(this, validationKeys);
      if (!validation) {
        return;
      }

      // If user exists or user logged in push user
      if(this.vg_userId) {
        this.user = {
          first_name: this.vg_user.first_name, 
          last_name: this.vg_user.last_name,
          phone: this.vg_user.phone,
          email: this.vg_user.email,
          sms_notification: this.vg_user.sms_notification ? true : false,
          email_notification: this.vg_user.email_notification,
          marketing_notification: this.vg_user.marketing_notification,
        };
      }

      // Append tip
   
      // validate pickuptime 
      if(!this.pickupTime && !this.defaultPickupTime) {
        return this.va_snackbar({
          type: "warning",
          message: 'Sorry we dont have any '+this.order_receive_method+' schedule available.',
        });
      } else if (!this.pickupTime && this.defaultPickupTime) {
        this.pickupTime = this.defaultPickupTime;
      }

      // Before we set we need to fetch data from green pos

      if(this.vg_is_greenline_pos) {
        this.va_spinner(true)
        await this.fetchGreenLinePosData();
        this.va_spinner(false)

      } else if( this.vg_is_tendy_pos) {
        this.va_spinner(true)
        await this.fetchTendyPosData()
        this.va_spinner(false)
      }

      let data = {
        tip: this.tip.amount ? this.tip.amount : 0,
        pickupTime: this.pickupTime,
        order_receive_method: this.order_receive_method,
        delivery: this.delivery,
        delivery_fee: this.delivery_fee,
        grandTotal: this.cartGrandTotalWithDelivery,
        user: this.user,
        note: this.note,
      };
      
      await this.va_setOrderTypeValueByKeys(data);
      // validate before changing tab
      bus.$emit('checkout-step', {
        step: 'payment',
      })
    },

     /**
     * Flush card data on vuex
     */
    resetCheckoutdata(withUser = false) {
      let objToReset =  {
        pickupTime: '',
        order_receive_method: 'pickup',
        delivery: {},
        delivery_fee: 0.00,
        grandTotal: 0.00,
        note: '',
      };
      if(withUser){
        objToReset.user = {};
      }
      this.va_setOrderTypeValueByKeys(objToReset);
    },

     /**
     * Fetch green pos
     */

    fetchGreenLinePosData: _.debounce( async function(){
      
      let receiveMethod = this.order_receive_method;
      // make the receive method pickup if no delivery  address
      if(receiveMethod == 'delivery' && this.delivery.address1 == '') {
        receiveMethod = 'pickup';
      }

      let prevalidateObj = {
        order_receive_method: receiveMethod,
      };
      // Get user details if logged in else default
      let fname = this.vg_userId ? this.vg_user.first_name : this.user.first_name;
      let lname = this.vg_userId ? this.vg_user.last_name : this.user.last_name;

      prevalidateObj.user = {
        first_name: fname ? fname : '-na-',
        last_name: lname ? lname : '-na-'
      }
      
      if( receiveMethod == 'delivery'){

        prevalidateObj.delivery_fee = this.delivery_fee;
        prevalidateObj.delivery = _.clone(this.delivery);
        if(this.delivery.address2 == ''){
          prevalidateObj.delivery.address2 = 'n/a';
        }
        if(this.delivery.phone == ''){
          prevalidateObj.delivery.phone = '0000000000';
        }
        
      }

      if(this.order_receive_method  == 'delivery') {
        prevalidateObj.tip = this.tip.amount ? this.tip.amount : 0;
      }
      await this.va_setGreenLinePosData(prevalidateObj);


    }, 1000),

    /**
     * Fetch Tendy pos
     */
    
    fetchTendyPosData: _.debounce( async function(){
      
      let receiveMethod = this.order_receive_method;
      // make the receive method pickup if no delivery  address
      if(receiveMethod == 'delivery' && this.delivery.address1 == '') {
        receiveMethod = 'pickup';
      }

      let obj = {
        order_receive_method: receiveMethod, 
        in_store: this.$store.getters['getInStore'] ? true : false,
      };

      // Get user details if logged in else default
      let fname = this.vg_userId ? this.vg_user.first_name : this.user.first_name;
      let lname = this.vg_userId ? this.vg_user.last_name : this.user.last_name;

      obj.user = {
        first_name: fname ? fname : '-na-',
        last_name: lname ? lname : '-na-'
      }
      
      if( receiveMethod == 'delivery'){
        obj.delivery_fee = parseFloat(this.delivery_fee);
        obj.delivery = _.clone(this.delivery);
        if(this.delivery.address2 == ''){
          obj.delivery.address2 = 'n/a';
        }
        if(this.delivery.phone == ''){
          obj.delivery.phone = '0000000000';
        }
      }

      if(this.order_receive_method == 'delivery') {
        obj.tip = this.tip.amount ? this.tip.amount : 0;
      }
      

      await this.va_setTendyPosData(obj);
      
    }, 1000),

    /**
     * Attch tip, gets on percent
     */
    selectTip(index) {
      this.tip.custom = false;
      this.tipDefinedPercents.map((x,i) => {
        x.active = (index == i) ? true : false;
      })
      let tipAmt = this.getTipPercentIntoAmt(this.tipDefinedPercents[index].value);
      this.tip.amount = tipAmt;
      this.tip.selected = this.tipDefinedPercents[index];

    },

    /**
     * Select custom tip
     */
    selectCustomTip() {
      this.tipDefinedPercents.map((x) => {
        x.active = false;
      })
      this.tip.selected = {};
      this.tip.amount = null;
      this.tip.custom = true;

    },

    /**
     * Attch tip
     */
    getTipPercentIntoAmt(val) {
      let subtotal = this.vg_cartSubTotal;
      return Math.round((subtotal/100)*val * 100) / 100;
    },
    /**
     * reset tip
     */
    resetTip() {
      this.tipDefinedPercents.map((x) => {
        x.active = false;
      })
      this.tip.selected = {};
      this.tip.amount = null;
      this.tip.custom = false;
    },

    /**
     * 
     * prevent non numbers
     */
    preventNonNumbers(e) {
      
      var ASCIICode = (e.which) ? e.which : e.keyCode
      if(ASCIICode == 43 || ASCIICode == 45 || ASCIICode == 187 || ASCIICode == 189){
        return false;
      }
      return true;
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setOrderTypeValueByKeys: "checkout/setOrderTypeValueByKeys",
      va_setCartLoyalityPointsObj: "cart/setLoyalityPointsObj",
      va_setGreenLinePosData: "cart/setGreenLinePosData",
      va_setTendyPosData: "cart/setTendyPosData",
    })

  },
};
</script>
<style scoped>
.input{
  border: 1px solid #e5e5e5 !important;
}
</style>

